import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white text-xl font-bold mb-4">JC Performance-57</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Spécialiste en gestion électronique automobile à Creutzwald. Reprogrammation moteur et optimisation de performances.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-red-600 text-sm">Accueil</a></li>
              <li><a href="/#services" className="text-gray-400 hover:text-red-600 text-sm">Services</a></li>
              <li><a href="/#tarifs" className="text-gray-400 hover:text-red-600 text-sm">Tarifs</a></li>
              <li><a href="/#contact" className="text-gray-400 hover:text-red-600 text-sm">Contact</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-400 text-sm">
                <Phone className="h-4 w-4 mr-2 text-red-600" />
                <a href="tel:0749995728" className="hover:text-red-600">07 49 99 57 28</a>
              </li>
              <li className="flex items-center text-gray-400 text-sm">
                <Mail className="h-4 w-4 mr-2 text-red-600" />
                <a href="mailto:Jc.performance57@outlook.fr" className="hover:text-red-600">Jc.performance57@outlook.fr</a>
              </li>
              <li className="flex items-start text-gray-400 text-sm">
                <MapPin className="h-4 w-4 mr-2 text-red-600 mt-0.5" />
                <span>14 rue saint Malo, 57150 Creutzwald</span>
              </li>
            </ul>
          </div>

          {/* Professional Space */}
          <div>
            <h4 className="text-white font-semibold mb-4">Espace Professionnel</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/professional/login" className="text-gray-400 hover:text-red-600 text-sm">
                  Connexion
                </Link>
              </li>
              <li>
                <Link to="/professional/register" className="text-gray-400 hover:text-red-600 text-sm">
                  Inscription
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} JC Performance-57. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;